<template>
	<div class="achievement-updater-container">
		<h2 class="level-one-heading">Uppdatera Achievements</h2>
		<p>
			Databas-katten håller koll på all din XP och achievements. Allting loggas noggrant, men systemen kan ibland ta tid på sig att visa uppdateringar från dina senaste köp.
		</p>
		<p>
			Med knappen nedan kan du skicka en vänlig påminnelse till databas-katten, så gör den sitt bästa att koppla om sladdar för att prioritera dina nya achievements.
		</p>
		<text-button
			center
			size="small"
			text="Be databas-katten om en uppdatering"
			:disabled="! userNotSentUpdateRequest"
			@click="updateAchievementsAndCloseModal"
		/>
		<p
			v-if="! userNotSentUpdateRequest"
			class="semibold"
		>
			Databas-Katten behöver vila tassarna lite innan du kan uppdatera nästa gång
		</p>
		<ximg
			:src="headerSrc"
			ariaLabel="Database Cat"
			role="img"
		/>
	</div>
</template>

<script>
import { convertToCdnUrl } from 'utils';
import alert from 'alert';
import { mapState } from 'vuex';

export default {
	props: ['user'],
	data() {
		return {
			achievementUpdated: false,
		};
	},
	computed: {
		headerSrc () {
			if (this.userNotSentUpdateRequest) {
				return convertToCdnUrl('/img/member/db-cat-ready.jpg');
			} else {
				return convertToCdnUrl('/img/member/db-cat-tired.jpg');
			}
		},
		userNotSentUpdateRequest () {
			return this.currentUser.settings.update_achievement_request == false;
		},
		...mapState ({
			currentUser: state => state.user,
		}),
	},
	methods: {
		updateAchievements() {
			if (! this.userNotSentUpdateRequest) {
				return;
			}

			const req = waja.put('setting/update_achievement_request?value=TRUE');

			req.on('success', res => {
				if (this.currentUser.settings.update_achievement_request = true) {
					this.achievementUpdated = true;
				} else {
					this.achievementUpdated = false;
				}
				alert('Databas-katten har fått din förfrågan och kommer att uppdatera dina achievements så snart som möjligt!');
			}).on('error', err => {
				this.currentUser.settings.update_achievement_request = false;
				alert('Något gick fel, försök igen senare.');
			}).go();
		},
		updateAchievementsAndCloseModal () {
			this.updateAchievements();
			this.$emit('close-modal');
		},
	},
}
</script>
